webpackJsonp([1],{

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(711),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b3c645c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(716),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(706),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0733dfda",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(717),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_luxon__);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  connected: false,
  name: '',
  photo: {
    data: '',
    source_index: 0,
    state: '',
    board: '',
    name: ''
  },
  chips: [],
  counters: {
    ok: 0,
    source: {
      current: 0,
      total: 0
    },
    rejects: []
  },
  start_chip: 0,
  start_time: __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local(),
  boards: [],
  heartbeat: __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO('2000-01-01T00:00:01.000Z'),
  last_hash: '',
  results: {}
};

var getters = {
  secsSinceLastUpdate: function secsSinceLastUpdate(state) {
    return Math.ceil(__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local().diff(state.heartbeat) / 1000);
  },
  stopped: function stopped(state) {
    return Math.ceil(__WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].local().diff(state.heartbeat) / 1000) > 600;
  }
};

var actions = {
  new_message: function new_message(_ref, msg) {
    var commit = _ref.commit;

    console.log('New message!', msg);
  }
};

function receivedChip(state, cd) {
  console.log('New chip', cd);
  if (!cd.tests) {
    cd.tests = [];
  }
  for (var ic = 0; ic < state.chips.length; ic++) {
    if (state.chips[ic].id === cd.id) {
      state.chips.splice(ic, 1);
      break;
    }
  }
  state.chips.splice(0, 0, cd);
  while (state.chips.length > 20) {
    state.chips.splice(state.chips.length - 1, 1);
  }
}

function receivedStats(state, stats) {
  console.log('Stats update', stats);
  state.name = stats.name;
  state.counters.ok = stats.state.next_ok;
  state.counters.source.current = stats.state.next_source;
  state.counters.source.total = stats.loaded.sources;
  state.start_chip = stats.start_chip;
  state.start_time = __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(stats.start_time);
  while (state.counters.rejects.length < stats.state.next_reject.length) {
    state.counters.rejects.splice(0, 0, { current: 0, total: 0, id: '' });
  }
  for (var ir = 0; ir < stats.state.next_reject.length; ir++) {
    state.counters.rejects[ir].current = stats.state.next_reject[ir];
    state.counters.rejects[ir].total = stats.loaded.rejects[ir].total;
    state.counters.rejects[ir].id = stats.loaded.rejects[ir].id || 'any';
  }
  for (ir = 0; ir < stats.state.boards.length; ir++) {
    if (state.boards.length <= ir) {
      state.boards.splice(ir, 0, stats.state.boards[ir]);
    } else {
      state.boards.splice(ir, 1, stats.state.boards[ir]);
    }
    state.boards[ir].id = stats.loaded.sockets[ir].id;
  }
}

function receivedPhoto(state, photo) {
  state.photo.data = photo.data;
  state.photo.source_index = photo.source_index;
  state.photo.state = photo.state;
  state.photo.board = photo.board;
  state.photo.name = photo.name;
}

function receivedResults(state, data) {
  console.log('Stats results', data);
  state.results = data;
}

var mutations = {
  SOCKET_ONERROR: function SOCKET_ONERROR(state, event) {
    console.log('EROR', state, event);
  },
  SOCKET_ONMESSAGE: function SOCKET_ONMESSAGE(state, msg) {
    var d = JSON.parse(msg.data);
    if (d.type === 'photo') {
      receivedPhoto(state, d.data);
      return;
    }
    if (d.type === 'chip') {
      receivedChip(state, d.data);
      return;
    }
    if (d.type === 'results') {
      receivedResults(state, d.data);
      return;
    }
    if (state.last_hash !== d.hash) {
      receivedStats(state, d.data);
      state.last_hash = d.hash;
      state.heartbeat = __WEBPACK_IMPORTED_MODULE_2_luxon__["DateTime"].fromISO(d.date);
    }
    // Change title
    document.title = 'Roboweb (' + state.name + ' ' + state.counters.source.current + '/' + state.counters.source.total + ')';
  },
  SOCKET_ONOPEN: function SOCKET_ONOPEN(state, msg) {
    state.connected = true;
  },
  SOCKET_ONCLOSE: function SOCKET_ONCLOSE(state, msg) {
    state.connected = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}));

/***/ }),

/***/ 272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_native_websocket__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_native_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_native_websocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_not_connected__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_not_connected___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_not_connected__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_view__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_main_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_main_view__);
//
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);



var cL = window.location;
if (__webpack_require__.i({"NODE_ENV":"production"}).URL) {
  console.log('Connecting to URL defined in the environment: ' + __webpack_require__.i({"NODE_ENV":"production"}).URL);
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_native_websocket___default.a, __webpack_require__.i({"NODE_ENV":"production"}).URL, { store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */] });
} else {
  var prot = 'ws:';
  if (location.protocol === 'https:') {
    prot = 'wss:';
  }
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_native_websocket___default.a, prot + '//' + cL.hostname + ':' + cL.port + '/ws', { store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */] });
}




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  components: {
    NotConnected: __WEBPACK_IMPORTED_MODULE_6__components_not_connected___default.a,
    MainView: __WEBPACK_IMPORTED_MODULE_7__components_main_view___default.a
  },
  computed: {
    isConnected: function isConnected() {
      return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].state.connected;
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var DTFMT = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ timeZoneName: 'short' }, __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].DATETIME_SHORT_WITH_SECONDS);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chip-data',
  props: {
    chip: Object
  },
  methods: {
    getLastTestResult: function getLastTestResult(chip) {
      if (!chip.tests || chip.tests.length === 0) {
        return '';
      }
      for (var i = chip.tests.length - 1; i >= 0; i--) {
        if (chip.tests[i].type !== 'validate') {
          continue;
        }
        return '(state ' + chip.tests[i].result + ')';
      }
    },
    formatTestType: function formatTestType(tt) {
      switch (tt) {
        case 'validate':
          return 'validation';
        case 'check_empty':
          return 'socket empty';
      }
      return tt;
    },
    formatTestTime: function formatTestTime(tt) {
      return __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].fromISO(tt).toLocaleString(DTFMT);
    },
    formatTestTimespan: function formatTestTimespan(ts) {
      var secs = Math.ceil(ts / 1000);
      var mins = Math.floor(secs / 60.0);
      return mins + 'm ' + (secs - mins * 60) + 's';
    },
    formatResult: function formatResult(row) {
      if (row.fail_tray.length > 0) {
        return row.result + ' (' + row.fail_tray + ')';
      }
      return row.result;
    }
  },
  computed: {
    getCodes: function getCodes() {
      var c = [];
      this.chip.recons.forEach(function (r) {
        r.codes.forEach(function (code) {
          c.push(code);
        });
      });
      return c;
    }
  }
});

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_progress__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__project_progress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__project_progress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project_error__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__project_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__project_finished__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__project_finished___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__project_finished__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__no_project_running__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__no_project_running___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__no_project_running__);
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main-view',
  components: {
    ProjectProgress: __WEBPACK_IMPORTED_MODULE_1__project_progress___default.a,
    ProjectError: __WEBPACK_IMPORTED_MODULE_2__project_error___default.a,
    ProjectFinished: __WEBPACK_IMPORTED_MODULE_3__project_finished___default.a,
    NoProjectRunning: __WEBPACK_IMPORTED_MODULE_4__no_project_running___default.a
  },
  computed: {
    hasError: function hasError() {
      for (var b in this.$store.state.boards) {
        for (var sk in b.sockets) {
          if (sk.status === 'abort') {
            return true;
          }
        }
      }
      return false;
    },
    secsSinceHeartbeat: function secsSinceHeartbeat() {
      var now = __WEBPACK_IMPORTED_MODULE_0_luxon__["DateTime"].local();
      return Math.ceil(now.diff(this.$store.state.heartbeat) / 1000);
    },
    hasFinished: function hasFinished() {
      var ps = this.$store.state.counters;
      if (ps.source.current < ps.source.total) {
        return false;
      }
      var running = false;
      this.$store.state.boards.forEach(function (b) {
        running = running || b.running;
      });
      return !running;
    },
    projectIsRunning: function projectIsRunning() {
      return this.secsSinceHeartbeat < 86400;
    }
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reconnect__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reconnect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__reconnect__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'no-project-running',
  components: { Reconnect: __WEBPACK_IMPORTED_MODULE_0__reconnect___default.a }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reconnect__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__reconnect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__reconnect__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'not-connected',
  components: { Reconnect: __WEBPACK_IMPORTED_MODULE_0__reconnect___default.a }
});

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'project-error',
	computed: {
		getErrorText: function getErrorText() {
			switch (this.$store.state.plc_state.error) {
				case 1:
					return 'Too many retries';
				case 2:
					return 'Robot doesn\'t know what to do';
				case 3:
					return 'Abort requested by robobrain';
				case 4:
					return 'Something is out of range';
				case 5:
					return 'There are no reject positions left';
			}
			return 'Unknown error';
		}
	}
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stats_card__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stats_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stats_card__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-finished',
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_0__stats_card___default.a
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stats_card__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stats_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__stats_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chip_data__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chip_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__chip_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sockets_card__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sockets_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sockets_card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__results_card__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__results_card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__results_card__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project-progress',
  components: {
    StatsCard: __WEBPACK_IMPORTED_MODULE_0__stats_card___default.a,
    ChipData: __WEBPACK_IMPORTED_MODULE_1__chip_data___default.a,
    SocketsCard: __WEBPACK_IMPORTED_MODULE_2__sockets_card___default.a,
    ResultsCard: __WEBPACK_IMPORTED_MODULE_3__results_card___default.a
  },
  computed: {
    getImageData: function getImageData() {
      return 'data:image/jpg;base64,' + this.$store.state.photo.data;
    },
    hasResults: function hasResults() {
      return 'stats' in this.$store.state.results;
    },
    numSockets: function numSockets() {
      var ns = 0;
      for (var ib = 0; ib < this.$store.state.boards.length; ib++) {
        var b = this.$store.state.boards[ib];
        ns += b.sockets.length;
      }
      return ns;
    }
  }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reconnect',
  data: function data() {
    return {
      secs_left: 5,
      interval: 0
    };
  },
  mounted: function mounted() {
    var self = this;
    this.interval = setInterval(function () {
      console.log('secs left are', self.secs_left);
      self.secs_left = self.secs_left - 1;
      if (self.secs_left <= 0) {
        location.reload();
      }
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.interval > 0) {
      clearInterval(this.interval);
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__results_plot__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__results_plot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__results_plot__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'results-card',
  components: { ResultsPlot: __WEBPACK_IMPORTED_MODULE_0__results_plot___default.a }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(655);

//
//
//
//
//
//



var pieArcs = __WEBPACK_IMPORTED_MODULE_1_d3__["a" /* pie */]().sort(null).value(function (d) {
  return d.value;
});

var cb1 = __WEBPACK_IMPORTED_MODULE_1_d3__["b" /* rgb */](251, 248, 176);
var cb2 = __WEBPACK_IMPORTED_MODULE_1_d3__["b" /* rgb */](209, 60, 75);

function linear(e, s, p, t) {
  return (e - s) * p / t + s;
}

function generatePlot(self, val) {
  if (!val) {
    return;
  }
  var pdata = [];
  var ft = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val.fail).length;
  for (var fn in val.fail) {
    var fo = {
      'name': fn || 'fail',
      'value': val.fail[fn]
    };
    var ip = 0;
    for (ip = 0; ip < pdata.length; ip++) {
      if (pdata[ip].value < fo.value) {
        pdata.splice(ip, 0, fo);
        break;
      }
    }
    if (ip === pdata.length) {
      pdata.push(fo);
    }
  }
  for (ip = 0; ip < pdata.length; ip++) {
    pdata[ip].color = __WEBPACK_IMPORTED_MODULE_1_d3__["b" /* rgb */](linear(cb1.r, cb2.r, ip, ft - 1), linear(cb1.g, cb2.g, ip, ft - 1), linear(cb1.b, cb2.b, ip, ft - 1));
  }
  if (val.ok > 0) {
    pdata.splice(0, 0, { 'name': 'ok', 'value': val.ok, 'color': __WEBPACK_IMPORTED_MODULE_1_d3__["b" /* rgb */](126, 201, 166) });
  }
  var arcs = pieArcs(pdata);
  var width = self.$refs['plotContainer'].getBoundingClientRect().width;
  width -= 10;
  var height = width;
  var sC = self.$refs['plot'];
  sC.setAttribute('height', height + 'px');
  sC.setAttribute('width', width + 'px');

  var arc = __WEBPACK_IMPORTED_MODULE_1_d3__["c" /* arc */]().innerRadius(0).outerRadius(Math.min(width, height) / 2 - 1);

  function arcLabel() {
    var radius = Math.min(width, height) / 2 * 0.6;
    return __WEBPACK_IMPORTED_MODULE_1_d3__["c" /* arc */]().innerRadius(radius).outerRadius(radius);
  }

  var svg = __WEBPACK_IMPORTED_MODULE_1_d3__["d" /* select */](sC).attr('text-anchor', 'middle').style('font', '12px sans-serif');
  var g = svg.append('g').attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  g.selectAll('path').data(arcs).enter().append('path').attr('fill', function (d) {
    return d.data.color;
  }).attr('stroke', 'white').attr('d', arc).append('title').text(function (d) {
    return d.data.name + ': ' + d.data.value.toLocaleString();
  });
  var text = g.selectAll('text').data(arcs).enter().append('text').attr('transform', function (d) {
    return 'translate(' + arcLabel().centroid(d) + ')';
  }).attr('dy', '0.35em');
  text.append('tspan').attr('x', 0).attr('y', '-0.7em').style('font-weight', 'bold').text(function (d) {
    return d.data.name;
  });
  text.filter(function (d) {
    return d.endAngle - d.startAngle > 0.25;
  }).append('tspan').attr('x', 0).attr('y', '0.7em').attr('fill-opacity', 0.7).text(function (d) {
    return d.data.value.toLocaleString();
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'results-plot',
  props: {
    data: Object
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    generatePlot(this, this.data);
  },

  watch: {
    data: function data(val, oldV) {
      generatePlot(this, val);
    }
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__results_plot__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__results_plot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__results_plot__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sockets-card',
  components: { ResultsPlot: __WEBPACK_IMPORTED_MODULE_0__results_plot___default.a },
  data: function data() {
    return {
      dialog: {
        visible: false,
        what: '',
        data: { ok: 0, fail: {} }
      }
    };
  },

  methods: {
    hasBoardResults: function hasBoardResults(ib) {
      if (!this.$store.state.results.boards) {
        return false;
      }
      return this.$store.state.results.boards[ib].stats.tests > 0;
    },
    showBoardResults: function showBoardResults(ib) {
      this.dialog.what = 'board ' + this.$store.state.boards[ib].id;
      this.dialog.data = this.$store.state.results.boards[ib].stats;
      this.dialog.visible = true;
    },
    hasSocketResults: function hasSocketResults(ib, is) {
      if (!this.hasBoardResults(ib)) {
        return false;
      }
      if (is >= this.$store.state.results.boards[ib].sockets.length) {
        return false;
      }
      return this.$store.state.results.boards[ib].sockets[is].tests > 0;
    },
    showSocketResults: function showSocketResults(ib, is) {
      this.dialog.what = 'board ' + this.$store.state.boards[ib].id + ' socket ' + is;
      this.dialog.data = this.$store.state.results.boards[ib].sockets[is];
      this.dialog.visible = true;
    },
    tableData: function tableData(board) {
      var data = [];
      for (var isk = 0; isk < board.sockets.length; isk++) {
        var sk = board.sockets[isk];
        data.push({
          'socket': isk,
          'chip_id': sk.chip_id,
          'fail_tray': sk.fail_tray,
          'result': sk.result,
          'current_retry': sk.current_retry,
          'retries': sk.retries,
          'source_index': sk.source_index,
          'state': board.running && sk.state !== 'disabled' && sk.state !== 'stopped' ? 'running' : sk.state,
          'v_tests': sk.validation_tests,
          'v_ok': sk.validation_oks,
          'v_fails': sk.validation_fails,
          'v_yield': sk.validation_tests === 0 ? 0 : Math.round(100 * (sk.validation_oks * 100.0 / (sk.validation_oks + sk.validation_fails))) / 100
        });
      }
      return data;
    },
    getCellStyle: function getCellStyle(cell) {
      switch (cell.row[cell.column.property]) {
        case 'ready':
          return { 'background-color': '#ABF', 'text-align': 'center', 'color': '#222', 'text-transform': 'capitalize' };
        case 'running':
          return { 'background-color': '#F6E1A3', 'text-align': 'center', 'color': '#222', 'text-transform': 'capitalize' };
        case 'done':
        case 'ok':
          return { 'background-color': '#AFA', 'text-align': 'center', 'color': '#505', 'text-transform': 'capitalize' };
        case 'retry':
        case 'fail':
          return { 'background-color': '#FAA', 'text-align': 'center', 'color': '#055', 'text-transform': 'capitalize' };
        case 'abort':
          return { 'background-color': '#F00', 'text-align': 'center', 'color': '#FF0', 'text-transform': 'uppercase', 'font-weight': 'bold' };
        case 'empty':
          return { 'background-color': '#FFF', 'text-align': 'center', 'color': '#111', 'text-transform': 'capitalize' };
        case 'disabled':
        case 'stopped':
          return { 'background-color': '#666', 'text-align': 'center', 'color': '#DDD', 'text-transform': 'capitalize' };
      }
      return '';
    }
  }
});

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_luxon__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var DTFMT = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ timeZoneName: 'short' }, __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].DATETIME_SHORT_WITH_SECONDS);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'stats-card',
  computed: {
    retriesTableData: function retriesTableData() {
      var data = [];
      for (var ib = 0; ib < this.$store.state.boards.length; ib++) {
        var b = this.$store.state.boards[ib];
        for (var isk = 0; isk < b.sockets.length; isk++) {
          data.push({ 'board': ib, 'socket': isk, 'retries': b.sockets[isk].retries });
        }
      }
      return data;
    },
    getTotalRetries: function getTotalRetries() {
      var rt = 0;
      for (var ib in this.$store.state.boards) {
        var b = this.$store.state.boards[ib];
        for (var isk in b.sockets) {
          rt += b.sockets[isk].retries;
        }
      }
      return rt;
    },
    getStartTime: function getStartTime() {
      return this.$store.state.start_time.toLocaleString(DTFMT);
    },
    getOverallProgress: function getOverallProgress() {
      var ps = this.$store.state.counters;
      if (ps.source.total === 0) {
        return 0;
      }
      return Math.round(ps.source.current / ps.source.total * 100);
    },
    getChipTested: function getChipTested() {
      var ps = this.$store.state.counters;
      var ret = '' + ps.source.current + ' / ' + ps.source.total;
      if (this.$store.state.start_chip > 0) {
        ret = ret + ' (started at chip ' + this.$store.state.start_chip + ')';
      }
      return ret;
    },
    getRejectOccupancy: function getRejectOccupancy() {
      return this.$store.counters.rejects.map(function (r) {
        if (r.current === 0) {
          return 0;
        }
        return Math.round(r.current / r.total * 100);
      });
    },
    getOKPercentage: function getOKPercentage() {
      var ps = this.$store.state.counters;
      var total = ps.ok;
      for (var ir in ps.rejects) {
        total += ps.rejects[ir].current;
      }
      if (total === 0) {
        return 0;
      }
      return Math.round(ps.ok * 100 / total);
    },
    getRejectedCurrentSum: function getRejectedCurrentSum() {
      var ps = this.$store.state.counters;
      var rejected = 0;
      for (var ir in ps.rejects) {
        rejected += ps.rejects[ir].current;
      }
      return rejected;
    },
    getRejectedTotalSum: function getRejectedTotalSum() {
      var ps = this.$store.state.counters;
      var rejected = 0;
      for (var ir in ps.rejects) {
        rejected += ps.rejects[ir].total;
      }
      return rejected;
    },
    getLastUpdate: function getLastUpdate() {
      var suf = '';
      if (this.$store.getters.stopped) {
        suf = ' (stopped)';
      }
      return this.$store.state.heartbeat.toLocaleString(DTFMT) + suf;
    },
    getChipsDone: function getChipsDone() {
      var ps = this.$store.state.counters;
      var cd = ps.source.current - this.$store.state.start_chip;
      this.$store.state.boards.forEach(function (b) {
        b.sockets.forEach(function (s) {
          if (b.state !== 'empty') {
            cd -= 1;
          }
        });
      });
      return cd;
    },
    getExpectedEndTime: function getExpectedEndTime() {
      var ps = this.$store.state.counters;
      var chips_tested = this.getChipsDone;
      if (chips_tested < 5) {
        return 'Can\'t calculate expected end time until some chips have been tested';
      }
      var elapsed_secs = Math.round(this.$store.state.heartbeat.diff(this.$store.state.start_time) / 1000);
      var secs_per_chip = elapsed_secs / chips_tested;
      var chips_left = ps.source.total - ps.source.current;
      var secs_left = Math.round(secs_per_chip * chips_left / 600) * 600;
      var endTime = __WEBPACK_IMPORTED_MODULE_1_luxon__["DateTime"].local().plus({ seconds: secs_left });
      var days_left = Math.floor(secs_left / 86400);
      var hours_left = Math.floor((secs_left - days_left * 86400) / 3600);
      var mins_left = Math.ceil((secs_left - (hours_left * 3600 + days_left * 86400)) / 60);
      return endTime.toLocaleString(DTFMT) + ' (' + days_left + 'd ' + hours_left + 'h ' + mins_left + 'm left)';
    },
    getAverageChipTime: function getAverageChipTime() {
      var chips_tested = this.getChipsDone;
      console.log('Tested in run', chips_tested);
      if (chips_tested < 5) {
        return 'Can\'t calculate expected end time until some chips have been tested';
      }
      var elapsed_secs = Math.round(this.$store.state.heartbeat.diff(this.$store.state.start_time) / 1000);
      var secs_per_chip = elapsed_secs / chips_tested;
      var mins_left = Math.floor(secs_per_chip / 60.0);
      var secs_left = Math.round(secs_per_chip - mins_left * 60);
      return '' + mins_left + 'm ' + secs_left + 's';
    },
    getImageData: function getImageData() {
      return 'data:image/jpg;base64,' + this.$store.state.photo.data;
    }
  }
});

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(707),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(709),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1cf4f3b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(718),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-da3083d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(712),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f7ec18a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(714),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4bbbbccf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(708),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19bd690a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(715),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-59fff7b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(710),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(713),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 706:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "stats-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Stats")]), _vm._v(" "), (_vm.$store.getters.stopped) ? _c('span', {
    staticClass: "stopwarn"
  }, [_vm._v("Not running")]) : _vm._e()]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Project name")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.$store.state.name) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Start time ")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getStartTime) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Expected end time")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getExpectedEndTime) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Chips tested ")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getChipTested) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Total retries done")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getTotalRetries) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Overall progress ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-progress', {
    attrs: {
      "text-inside": true,
      "stroke-width": 18,
      "percentage": _vm.getOverallProgress
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Average chip time ")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.getAverageChipTime) + " ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v(" Chips accepted ")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(" " + _vm._s(_vm.$store.state.counters.ok) + " (" + _vm._s(_vm.getOKPercentage) + "%) ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Total Chips rejected")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.getRejectedCurrentSum))])], 1), _vm._v(" "), _vm._l((_vm.$store.state.counters.rejects), function(reject, ir) {
    return _c('el-row', {
      key: ir
    }, [_c('el-col', {
      staticClass: "kv-key",
      attrs: {
        "span": 6
      }
    }, [_vm._v(" Chips rejected for sink " + _vm._s(ir))]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 18
      }
    }, [_c('div', {
      staticStyle: {
        "margin-bottom": "5px"
      }
    }, [_vm._v(_vm._s(reject.current) + " for " + _vm._s(reject.id) + " errors out for " + _vm._s(reject.total) + " available positions")]), _vm._v(" "), _c('el-progress', {
      attrs: {
        "status": "exception",
        "text-inside": true,
        "stroke-width": 18,
        "percentage": Math.round((reject.current / reject.total) * 100)
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "kv-key",
    attrs: {
      "span": 6
    }
  }, [_vm._v("Last update")]), _vm._v(" "), _c('el-col', {
    staticClass: "kv-value",
    attrs: {
      "span": 18
    }
  }, [_vm._v(_vm._s(_vm.getLastUpdate))])], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-collapse-item', {
    attrs: {
      "title": "Chip " + _vm.chip.id + " " + _vm.getLastTestResult(_vm.chip)
    }
  }, [_vm._l((_vm.chip.positions), function(pos, ipos) {
    return _c('h4', [_vm._v("Position " + _vm._s(pos.position.X) + "x" + _vm._s(pos.position.Y) + " to corrected " + _vm._s(pos.corrected_position.X) + "x" + _vm._s(pos.corrected_position.Y))])
  }), _vm._v(" "), (_vm.chip.tests.length > 0) ? _c('div', [_c('h4', [_vm._v("Tests")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.chip.tests
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Date",
      "width": "190"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTestTime(scope.row.timestamp)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Type",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTestType(scope.row.type)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Timespan",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatTestTimespan(scope.row.timespan)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Result",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatResult(scope.row)))])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getCodes && _vm.getCodes.length > 0) ? _c('div', [_c('h4', [_vm._v("Codes")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.getCodes
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "Type",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "data",
      "label": "Data",
      "width": "350"
    }
  })], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('h1', [_vm._v("Run finished")]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('stats-card'), _vm._v(" "), _c('el-card', {
    staticClass: "video",
    attrs: {
      "body-style": {
        height: '100%',
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Done!")])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": "https://www.youtube.com/embed/6ktnrKG8uq4?autoplay=1&cc_load_policy=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [(_vm.hasError) ? _c('project-error') : (_vm.hasFinished) ? _c('project-finished') : (_vm.projectIsRunning) ? _c('project-progress') : _c('no-project-running')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 710:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "results-card",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Breakdown of test results")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('results-plot', {
    attrs: {
      "data": _vm.$store.state.results.stats
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_vm._v("Reloading in " + _vm._s(_vm.secs_left) + " seconds...")])
},staticRenderFns: []}

/***/ }),

/***/ 712:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v("Not connected")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v(" ")])])], 1), _vm._v(" "), _c('reconnect')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 713:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "sockets-card",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Sockets")])]), _vm._v(" "), _vm._l((_vm.$store.state.boards), function(board, isb) {
    return _c('div', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('h4', {
      staticClass: "board-header"
    }, [_c('i', {
      staticClass: "el-icon-info",
      on: {
        "click": function($event) {
          _vm.showBoardResults(isb)
        }
      }
    }), _vm._v(" Board " + _vm._s(board.id)), (board.running) ? _c('span', {
      staticStyle: {
        "color": "#393"
      }
    }, [_vm._v(" (running test)")]) : _vm._e(), _vm._v(" has run\n      " + _vm._s(board.tests_done) + " tests "), (board.error) ? _c('span', {
      staticStyle: {
        "color": "#939"
      }
    }, [_vm._v(_vm._s(board.error))]) : _vm._e()]), _vm._v(" "), _c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.tableData(board),
        "header-cell-style": {
          color: '#000'
        },
        "cell-style": _vm.getCellStyle
      }
    }, [_c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "socket",
        "label": "Socket"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n         " + _vm._s(scope.row.socket) + "\n          "), (_vm.hasSocketResults(isb, scope.row.socket)) ? _c('i', {
            staticClass: "el-icon-info",
            on: {
              "click": function($event) {
                _vm.showSocketResults(isb, scope.row.socket)
              }
            }
          }) : _vm._e()]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "80px",
        "prop": "state",
        "label": "State"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "current_retry",
        "label": "Retried"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "chip_id",
        "label": "Chip ID"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "result",
        "label": "Result"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "fail_tray",
        "label": "Fail tray"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "source_index",
        "label": "Source"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "v_tests",
        "label": "Tests"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "v_ok",
        "label": "Ok"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "v_fails",
        "label": "Fails"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "v_yield",
        "label": "Yield"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "width": "75px",
        "prop": "retries",
        "label": "Retries"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Result breakdown for ' + _vm.dialog.what,
      "visible": _vm.dialog.visible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.$set(_vm.dialog, "visible", $event)
      }
    }
  }, [_c('results-plot', {
    attrs: {
      "data": _vm.dialog.data
    }
  })], 1)], 2)
},staticRenderFns: []}

/***/ }),

/***/ 714:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("\n\t\t\t\t " + _vm._s(_vm.getErrorText) + " \n\t\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "video",
    attrs: {
      "span": 16
    }
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": "http://www.youtube.com/embed/SkgTxQm9DWM?autoplay=1&cc_load_policy=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 715:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('h1', [_vm._v("Running stats for " + _vm._s(_vm.$store.state.name))]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('stats-card'), _vm._v(" "), (_vm.$store.state.photo.data.length > 0) ? _c('el-card', {
    staticClass: "photo-card",
    attrs: {
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Last photo of chip " + _vm._s(_vm.$store.state.photo.chip_id) + " in state " + _vm._s(_vm.$store.state.photo.state))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.getImageData
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('sockets-card'), _vm._v(" "), (_vm.hasResults) ? _c('results-card') : _vm._e(), _vm._v(" "), (_vm.$store.state.chips.length > 0) ? _c('el-card', {
    staticClass: "chips-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Last chips tested")])]), _vm._v(" "), _c('el-collapse', _vm._l((_vm.$store.state.chips), function(chip) {
    return _c('chip-data', {
      key: chip.id,
      attrs: {
        "chip": chip
      }
    })
  }))], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 716:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "plotContainer"
  }, [_c('svg', {
    ref: "plot"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 717:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.isConnected) ? _c('main-view') : _c('not-connected')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 718:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v("No project is running.")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_vm._v(" ")])])], 1), _vm._v(" "), _c('reconnect')], 1)
},staticRenderFns: []}

/***/ })

},[270]);


// WEBPACK FOOTER //
// static/js/app.d87ce4666be6209d0113.js